import React, { useState } from "react";
import Select from "react-select";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export default function Violation() {
    const [selectedParameter, setSelectedParameter] = useState(null);
    const [searchText, setSearchText] = useState("");

    const vehicleOptions = [...Array(10).keys()].map((i) => ({
        value: `KA0${i + 1}AB1234`,
        label: `KA0${i + 1}AB1234`,
    }));
    const data = [
        { id: 1, date: "2024-02-20", vehicleNo: "KA01AB1234", kmSoc: 3.5, finalOdo: 12050, maxSpeed: 95, startTime: "08:00", avgSpeed: 45, travelledDistance: 120, finalSoc: 70, initialOdo: 11930, initialSoc: 90, duration: "2h", endTime: "10:00", socConsumption: 20, speedLimit: 60, location: "Main Highway", count: 3 },
        { id: 2, date: "2024-02-21", vehicleNo: "MH12CD5678", kmSoc: 3.8, finalOdo: 15030, maxSpeed: 85, startTime: "09:15", avgSpeed: 50, travelledDistance: 150, finalSoc: 65, initialOdo: 14880, initialSoc: 85, duration: "2h 30m", endTime: "11:45", socConsumption: 22, speedLimit: 50, location: "City Center", count: 2 },
        { id: 3, date: "2024-02-22", vehicleNo: "DL05EF9012", kmSoc: 3.2, finalOdo: 17320, maxSpeed: 100, startTime: "07:30", avgSpeed: 48, travelledDistance: 110, finalSoc: 60, initialOdo: 17210, initialSoc: 88, duration: "2h", endTime: "09:30", socConsumption: 18, speedLimit: 80, location: "Expressway", count: 1 },
        { id: 4, date: "2024-02-23", vehicleNo: "TN09GH3456", kmSoc: 3.9, finalOdo: 13500, maxSpeed: 75, startTime: "06:45", avgSpeed: 52, travelledDistance: 140, finalSoc: 75, initialOdo: 13360, initialSoc: 92, duration: "2h 15m", endTime: "09:00", socConsumption: 19, speedLimit: 50, location: "Ring Road", count: 4 },
        { id: 5, date: "2024-02-24", vehicleNo: "AP16IJ7890", kmSoc: 3.7, finalOdo: 14550, maxSpeed: 110, startTime: "10:00", avgSpeed: 47, travelledDistance: 130, finalSoc: 68, initialOdo: 14420, initialSoc: 89, duration: "2h 10m", endTime: "12:10", socConsumption: 21, speedLimit: 70, location: "Industrial Area", count: 2 },
        { id: 6, date: "2024-02-25", vehicleNo: "GJ18KL2345", kmSoc: 3.6, finalOdo: 16000, maxSpeed: 90, startTime: "11:00", avgSpeed: 49, travelledDistance: 135, finalSoc: 72, initialOdo: 15865, initialSoc: 91, duration: "2h 5m", endTime: "13:05", socConsumption: 19, speedLimit: 60, location: "Metro Road", count: 3 },
        { id: 7, date: "2024-02-26", vehicleNo: "RJ20MN6789", kmSoc: 3.4, finalOdo: 18000, maxSpeed: 80, startTime: "14:30", avgSpeed: 46, travelledDistance: 125, finalSoc: 67, initialOdo: 17875, initialSoc: 86, duration: "2h 15m", endTime: "16:45", socConsumption: 19, speedLimit: 50, location: "Bridge Road", count: 1 },
        { id: 8, date: "2024-02-27", vehicleNo: "UP22OP1234", kmSoc: 3.3, finalOdo: 19050, maxSpeed: 95, startTime: "17:00", avgSpeed: 48, travelledDistance: 140, finalSoc: 69, initialOdo: 18910, initialSoc: 88, duration: "2h 10m", endTime: "19:10", socConsumption: 19, speedLimit: 55, location: "Highway Exit", count: 2 },
    ];

    const columns = [
        { name: "S.No", selector: (row) => row.id, sortable: true },
        { name: "Vehicle No", selector: (row) => row.vehicleNo, sortable: true },
        { name: "Max Speed", selector: (row) => row.maxSpeed, sortable: true },
        { name: "Duration", selector: (row) => row.duration, sortable: true },
        { name: "Speed Limit", selector: (row) => row.speedLimit, sortable: true },
        { name: "Location", selector: (row) => row.location, sortable: true },
        { name: "Date", selector: (row) => row.date, sortable: true },
        { name: "Count", selector: (row) => row.count, sortable: true },
    ];


     const handleExportPDF = () => {
        const doc = new jsPDF();
        autoTable(doc, {
            head: [columns.map((col) => col.name)],
            body: filteredData.map((row) => columns.map((col) => row[col.selector ? col.selector(row) : row[col.name]])),
        });
        doc.save("trips-data.pdf");
    };
    const customStyles = {
        headCells: {
            style: {
                backgroundColor: "#888888 ",
                color: "#ffffff",
                fontWeight: "bold",
            },
        },
    };
    const filteredData = data.filter((row) =>
        Object.values(row).some((val) =>
            val.toString().toLowerCase().includes(searchText.toLowerCase())
        )
    );

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0 font-size-18">Violation </h4>
                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><a href="#/">Dashboard</a></li>
                                <li className="breadcrumb-item active">Violation</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header p-1 pt-2">
                            <div className="row mb-3 d-flex justify-content-center">
                                <div className="col-sm-12 col-md-12 col-lg-3 mb-1">
                                    <label>Select Vehicle</label>
                                    <Select
                                        options={vehicleOptions}
                                        value={selectedParameter}
                                        onChange={setSelectedParameter}
                                        isSearchable={true} // Enables search
                                        placeholder="Select Vehicle"
                                        className="basic-single"
                                        classNamePrefix="select"
                                    />
                                </div>

                                <div className="col-sm-12 col-md-12 col-lg-2 mb-1">
                                    <label>From</label>
                                    <input type="date" className="form-control" />
                                </div>
                                <div className="col-sm-12 col-md-12 col-lg-2 mb-1">
                                    <label>To</label>
                                    <input type="date" className="form-control" />
                                </div>
                                <div className="col-md-1 mt-4">
                                    <input type="submit" value="Search" className="mt-1 btn btn-primary waves-effect waves-light" />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between mb-3">
                                <div>
                                    <CSVLink data={filteredData} filename="trips-data.csv" className="btn btn-primary btn-sm me-2">
                                        Export to CSV
                                    </CSVLink>
                                    <button onClick={handleExportPDF} className="btn btn-danger btn-sm">
                                        Export to PDF
                                    </button>
                                </div>
                                <div className="col-lg-2">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search..."
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                    />
                                </div>
                            </div>
                            <DataTable
                                columns={columns}
                                data={filteredData}
                                pagination
                                highlightOnHover
                                responsive
                                customStyles={customStyles}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
